export default __webpack_public_path__ + "static/03-68860903743517725b471fe51d45ee21.gif";